import { SerializableKeyEvent } from "@multiweb/types/react";
import {
    ACTION_ITEM_FOCUSED,
    CLEAR_FOCUSED_ITEM,
    CLEAR_NAVIGATION_SECTION,
    FOCUS_DEFAULT_ITEM,
    KEY_PRESSED,
    MENU_FOCUS_LOST,
    NAVIGATION_NODES_UPDATED,
    SET_FOCUSED_ITEM,
    SET_NAVIGATION_NODES,
} from "./constants";
import {
    FocusableItemId,
    IActionItemFocusedAction,
    IClearFocusedItemAction,
    IClearNavigationSectionAction,
    IFocusDefaultItemAction,
    IKeyPressedAction,
    IMenuFocusLostAction,
    INavigationNodesUpdatedAction,
    ISetFocusedItemAction,
    ISetNavigationNodesAction,
    NavigationNode,
    NavigationSection,
} from "./types";

/**
 * Akce pro nastavení zaměřené položky v menu.
 * @param focusedItemId Id zaměřitelné položky, která má být zaměřená.
 */
export const createSetFocusedItemAction = (focusedItemId: FocusableItemId): ISetFocusedItemAction => ({
    type: SET_FOCUSED_ITEM,
    payload: {
        focusedItemId,
    },
});

/**
 * Akce pro nastavení zaměření na výchozí hodnotu, pokud není nic zaměřené.
 */
export const createFocusDefaultItemAction = (): IFocusDefaultItemAction => ({
    type: FOCUS_DEFAULT_ITEM,
});

/**
 * Akce pro zrušení zaměření.
 */
export const createClearFocusedItemAction = (): IClearFocusedItemAction => ({
    type: CLEAR_FOCUSED_ITEM,
});

/**
 * Akce pro nastavení navigačních uzlů do stavu.
 * @param section Navigační sekce, do které uzly patří.
 * @param navigationNodes Navigační uzly k nastavení.
 */
export const createSetNavigationNodesAction = (section: NavigationSection, ...navigationNodes: NavigationNode[]): ISetNavigationNodesAction => ({
    type: SET_NAVIGATION_NODES,
    payload: {
        section,
        navigationNodes,
    },
});

/**
 * Akce pro smazání všech navigačních uzlů v zadané sekci.
 * @param section Navigační sekce k vyčištění.
 */
export const createClearNavigationSectionAction = (section: NavigationSection): IClearNavigationSectionAction => ({
    type: CLEAR_NAVIGATION_SECTION,
    payload: {
        section,
    },
});

/**
 * Akce indikující, že byla dokončena aktualizace navigačních uzlů pro danou sekci.
 * @param sectionType
 */
export const createNavigationNodesUpdatedAction = (sectionType: NavigationSection): INavigationNodesUpdatedAction => ({
    type: NAVIGATION_NODES_UPDATED,
    payload: {
        sectionType,
    },
});

/**
 * Akce indikující stisknutí klávesy v menu.
 * @param event Serializovatelná událost stisku klávesy.
 */
export const createKeyPressedAction = (event: SerializableKeyEvent): IKeyPressedAction => ({
    type: KEY_PRESSED,
    payload: {
        event,
    },
});

/**
 * Akce indikující ztrátu zaměření celého menu.
 * @param documentHidden Příznak, zda je dokument skrytý nebo viditelný.
 */
export const createMenuFocusLostAction = (documentHidden: boolean): IMenuFocusLostAction => ({
    type: MENU_FOCUS_LOST,
    payload: {
        documentHidden,
    },
});

/**
 * Akce indikující, že proběhlo zaměření akční položky.
 * @param focusableItemId Identifikátor zaměřené položky z pohledu navigace.
 */
export const createActionItemFocusedAction = (focusableItemId: FocusableItemId): IActionItemFocusedAction => ({
    type: ACTION_ITEM_FOCUSED,
    payload: {
        focusableItemId,
    },
});
